import React, { useState, useEffect, useRef } from 'react';
import './styles.css';

const YouTubeShort = ({ url }) => {
  const [loaded, setLoaded] = useState(false);
  const [retryKey, setRetryKey] = useState(0);
  const [hasTimedOut, setHasTimedOut] = useState(false);
  const timeoutRef = useRef(null);

  const getVideoId = (originalUrl) => {
    if (!originalUrl) return '';
    let videoId = '';
    if (originalUrl.includes('youtube.com/shorts/')) {
      videoId = originalUrl.split('youtube.com/shorts/')[1].split('?')[0];
    } else if (originalUrl.includes('watch?v=')) {
      videoId = originalUrl.split('watch?v=')[1].split('&')[0];
    } else if (originalUrl.includes('youtu.be/')) {
      videoId = originalUrl.split('youtu.be/')[1].split('?')[0];
    } else {
      videoId = originalUrl;
    }
    return videoId;
  };

  const videoId = getVideoId(url);
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const embedUrl = videoId
    ? `https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0&enablejsapi=1${origin ? `&origin=${encodeURIComponent(origin)}` : ''}`
    : '';

  useEffect(() => {
    if (!url) return;
    setLoaded(false);
    setHasTimedOut(false);

    timeoutRef.current = setTimeout(() => {
      setHasTimedOut(true);
    }, 7000);

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [retryKey, url]);

  if (!url) return null;

  const handleIframeLoad = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setLoaded(true);
    setHasTimedOut(false);
  };

  const handleRetry = () => {
    setLoaded(false);
    setHasTimedOut(false);
    setRetryKey(prev => prev + 1);
  };

  return (
    <div className="youtube-short-wrapper">
      <div className="youtube-short-inner">
        {!loaded && (
          <div className="youtube-short-skeleton">
            <div className="youtube-short-spinner"></div>
            {hasTimedOut && (
              <button className="youtube-retry-btn" onClick={handleRetry}>
                Reload Video
              </button>
            )}
          </div>
        )}
        <iframe
          key={retryKey}
          width="100%"
          height="100%"
          src={embedUrl}
          title="YouTube Short"
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          onLoad={handleIframeLoad}
          style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.3s ease' }}
        ></iframe>
      </div>
    </div>
  );
};

export default YouTubeShort;
